module.exports = __webpack_public_path__ + "img/suggestion_icon_chat.492c13a0.svg";